import Navbar from "./components/Header/Navbar";
import Hero from "./components/Hero/Hero";
import NewLaunches from "./components/NewLaunches/NewLaunches";
import DigitalExperience from "./components/DigitalExperience/DigitalExperience";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Toaster } from "react-hot-toast";
import SustainableLiving from "./components/SustainableLiving/SustainableLiving";
import ModernElegance from "./components/ModernElegance/ModernElegance";
import Payment from "./components/Payment/Payment";
import LocationMap from "./components/Properties/LocationMap";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <div className="relative min-h-screen w-full overflow-hidden bg-gradient-to-b from-gray-50 to-white">
        <Toaster />
        <Navbar />
        <main className="relative w-full">
          <Hero />
          <SustainableLiving/>
          <ModernElegance/>
          <NewLaunches />
          <LocationMap/>
          <Payment/>
          <DigitalExperience />
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
